import React from "react";
import { FileUpload, BarChart, PieChart } from "@mui/icons-material";

export const hmsMenus = [

  //Patient Management
  //  {
  //   label: "Patient Management",
  //   icon: <FileUpload />,
  //   children: [
  //     {
  //       label: "Register New Patient",
  //       icon: <BarChart />,
  //       children: [
  //         { label: "OUTDoor", icon: <BarChart /> },
  //         { label: "InDoor", icon: <BarChart /> }
  //       ]
  //     },
  //     { label: "Search / View Patients", icon: <BarChart /> },
  //     { label: "Patient History", icon: <BarChart /> },
  //     { label: "Patient Documents", icon: <BarChart /> },
  //     { label: "Insurance & TPA Management", icon: <BarChart /> }
  //   ]
  // },

  {
    label: "Patient Management",
    //icon: <FileUpload />,
icon: <span style={{ fontSize: "1.5rem" }}>🗣</span>, // use any emoji here
  },
 
  //OPD
  {
    
    label: "OPD", icon: <span style={{ fontSize: "1.5rem" }}>🏨</span>,
  },

  //IPD

  {
    label: "IPD", icon: <span style={{ fontSize: "1.5rem" }}>🏪</span>,
  },

  {
    label: "Ward / Bed Management", icon: <span style={{ fontSize: "1.5rem" }}>🛌</span>,
  },


  //Doctor Management
  
  // {
  //   label: "Doctor Management", 
  //   icon: <span style={{ fontSize: "1rem" }}>👨‍⚕️</span>,
  // },

  //Staff Management
  {
    label: "Staff Management", icon: <span style={{ fontSize: "1rem" }}>👩🏽‍🍳</span>,
    
  },

  //Accounts & Billing
  {
    label: "Accounts & Billing", icon: <span style={{ fontSize: "1.5rem" }}>📊</span>,

   
  },

  //Pharmacy / Medical Store
  {
    label: "Pharmacy / Medical Store", icon: <span style={{ fontSize: "1rem" }}>💊</span>,

    
  },

  //Radiology / Lab Management
  {
    label: "Radiology / Lab Management", icon: <span style={{ fontSize: "1.5rem" }}>🕵️‍♂️</span>,
    

  },

  //Medicine / Inventory Management  
  {
    label: "Medicine / Inventory Management", icon: <span style={{ fontSize: "1.5rem" }}>📉</span>,

  },
  //Reports & Analytics

  {
    label: "Reports & Analytics", icon: <span style={{ fontSize: "1.5rem" }}>🖨️</span>,

    
  },


  //Administration (Admin Panel)

  {
    label: "Administration (Admin Panel)", icon: <span style={{ fontSize: "1.5rem" }}>🎖</span>,
    
  },


  //Security & Audit

  {
    label: "Security & Audit", icon: <span style={{ fontSize: "1.5rem" }}>🛠</span>,
   
  },

];
